// extracted by mini-css-extract-plugin
export default {"photo":"Picture_photo__3Bz2J","img":"Picture_img__ZobDV"};